import { TypedUseSelectorHook, useSelector } from "react-redux";
import { RootState } from "../configureStore";

const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default useAppSelector;
